<script setup lang="ts">
import { StackedLayout } from "@xy-planning-network/trees"
import InitialProps from "@/types/root"
import Logo from "@/assets/logo-wide.svg"
import { useBaseNavigation } from "@/composables/navigation"
import Footer from "@/components/shared/Footer.vue"

const { currentUser } = window.InitialVueProps.initialProps as InitialProps
const baseNavigation = useBaseNavigation(currentUser)
const userNavigation = [
  { name: "Account Settings", url: "/account-settings", show: true },
  { name: "Billing", url: "/billing", show: currentUser.account?.nonMember },
  { name: "Sign out", url: "/logoff", show: true },
].filter((nav) => {
  return nav.show
})
const currentPath = window.location.pathname || "/"
</script>
<template>
  <StackedLayout
    :active-url="currentPath"
    :current-user="currentUser"
    :icon-url="Logo"
    :navigation="baseNavigation"
    :user-navigation="userNavigation"
  >
    <template v-for="(_, name) in $slots" #[name]="slotData"
      ><slot :name="name" v-bind="slotData"
    /></template>
  </StackedLayout>

  <Footer bg="bg-gray-100"></Footer>
</template>
